export enum StatesEnum {
  RELEASED = 'RELEASED',
  SAVED = 'SAVED',
  PENDING = 'PENDING',
}
